
















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { item } from "@/components/shared/ItemSelection.vue";

@Component<ItemGroup>({})
export default class ItemGroup extends Vue {
  @Prop({ required: true })
  items: number[];
  @Prop({ required: true })
  itemConfig: item[];
}
